{
  "version": 1,
  "crops": {
    "corn": {
      "p2o5": 0.37,
      "k2o": 0.27,
      "label": "Corn (grain)"
    },
    "soybean": {
      "p2o5": 0.8,
      "k2o": 1.4,
      "label": "Soybean"
    },
    "wheat": {
      "p2o5": 0.5,
      "k2o": 0.3,
      "label": "Wheat"
    }
  },
  "default_yield": {
    "corn": 220,
    "soybean": 80,
    "wheat": 80
  },
  "default_season_crops": [
    "corn",
    "soybean"
  ]
}
